export const SESSION_STORAGE_AIR_REDIRECT_ERROR = 'air-redirect-error';
export const SESSION_STORAGE_LAST_SELECTED_RETURN_FLIGHT = 'last-selected-return-flight';
export const SESSION_STORAGE_LAST_BOOKED_RESERVATION = 'last-booked-reservation';
export const SESSION_STORAGE_CURRENT_BOOKING = 'current-booking';
export const PAY_NOW = 'payNow';
export const BOOKING_STATUS = {
  courtesy_hold: 'CH',
  booked: 'BOOKED',
};
export const SESSION_STORAGE_GDS_LOCATOR = 'info-by-locator';
export const SESSION_STORAGE_LAST_PAYMENT = 'last-payment';
export const SESSION_STORAGE_LAST_BROWSE_PARAMS = 'last-browse-params';
export const SESSION_STORAGE_LAST_SEARCH_PARAMS = 'last-search-params';
export const SESSION_STORAGE_LAST_SELECTED_DEPARTURE_FLIGHT = 'last-selected-departure-flight';
export const SESSION_STORAGE_BOOKING_TOKEN_NAME = 'x-booking-token';
export const PROFILE_BOOKING_DATA = 'profile-booking-data';
export const DUPLICATE_CONFIRMATION_ERROR = 'Duplicate Confirmation';
export const SESSION_STORAGE_CURRENT_SAILING = 'current-sailing';
export const SESSION_STORAGE_LAST_DEPARTURE_FLIGHT_RESULTS = 'last-departure-flight-results';
export const SESSION_STORAGE_LAST_HELD_RESERVATION = 'last-held-reservation';
export const SESSION_STORAGE_LAST_RETURN_FLIGHT_RESULTS = 'last-return-flight-results';
export const SESSION_STORAGE_GIFTCARD_PAYMENT = 'giftcard-payment-amount';
export const SESSION_STORAGE_NO_FLIGHTS_RESULTS_ERROR = 'no-flight-results-error';
export const SESSION_STORAGE_CHANGE_FLIGHTS = 'enable-change-flights';
export const SESSION_STORAGE_BOOKING_PROFILE_NAME = 'booking-profile';
export const SESSION_STORAGE_AKAMAI_COUNTRY = 'akamaiCountry';
export const SESSION_STORAGE_CANCEL_FLIGHT_RESPONSE = 'cancel-flight-response';
export const SESSION_STORAGE_AVAILABLE_TRANSFERS = 'available-transfers';
export const SESSION_STORAGE_LAST_ID_AIR_FLAGS = 'last-id-air-flags';
export const SESSION_STORAGE_SEARCH_TYPE = 'search-type-tab';
export const SESSION_STORAGE_LAST_FILTER_PANEL = 'last-filter-panel';
export const SESSION_STORAGE_SEARCH_BACK = 'search-back';
export const SESSION_STORAGE_CURRENT_DATA_FLIGHT = 'current-data-flight';
export const SESSION_STORAGE_CURRENT_EXTRADATA_FLIGHT = 'current-extradata-flight';
export const SESSION_STORAGE_AMEND_ORIGIN = 'amend-origin';
export const OUTBOUND = 'OUTBOUND';
export const CANCEL_FLIGHT_RESPONSE_SUCCESSFUL = 'CANCELLED';
export const SESSION_STORAGE_LAST_PARAMS = 'last-params';
export const CHANGE_FLIGHT_MODE = 'amend';
export const SESSION_STORAGE_FLIGHT_TYPE_CODE = 'flight-type-code';
export const INBOUND = 'INBOUND';
export const SESSION_STORAGE_IS_REFUND = 'refund-payment';
export const SESSION_STORAGE_TOTAL_GUEST_SELECTED_FLIGHT = 'total-guest-selected';
export const SESSION_STORAGE_NAVIGATION_HISTORY_LAST_ENTRY = 'navigation-history-last-entry';
export const SESSION_STORAGE_TARGET_CAMPAIGN_UPC_ENABLED = 'tc-enabled-unified-payment';
export const FLIGHT_TYPES = {
  MULTI_DESTINATION: 'Multi-Destination',
  ROUND_TRIP: 'Round Trip',
};

export const ENABLE_CRUISE_BOOKING_TYPE_FLAG = 'enable-cruise-booking-types';
export const ENABLE_ONE_WAY_FLAG = 'enable-one-way';
export const ENABLE_SIGN_IN_FLAG = 'enable-sign-in';
export const ENABLE_JIRA_WIDGET = 'enable-jira-widget';
export const ENABLE_AFFIRM_FLAG = 'enable-unified-payment-component';
export const ENABLE_UNIFIED_PAYMENT_FLAG = 'enable-unified-payment-component';
export const ENABLE_QUICK_BOOK = 'browse-quick-book-enabled';
export const ENABLE_HOTELS_CTA = 'enable-hotels-cta';
export const ENABLE_OPEN_SEARCH = 'enable-open-search';
export const APPLICATION_NAME = 'AIR';
export const MARKETING_TAGS_URL = 'markets/marketing-tags';
export const BOOKING_COUNTRY = 'bookingCountry';
export const CACHE_PERSIST = 'apollo-cache-persist';
export const SESSION_STORAGE_GUEST_ACCOUNT_LOGGED = 'guest-account-logged';
export const SUPPORT_PHONE_NUMBER_LD_FLAG = 'air-support-phone-number';

export const NAVIGATION_PATHS = {
  base: '/flights',
  error: '/error',
  reservation: '/reservation/dashboard',
  reservationLookup: '/reservation/lookup',
  resultsDeparture: '/results/departure',
  reservationPayment: '/reservation/payment',
  payment: '/payment',
  reviewFlight: '/review-flight',
  confirmation: '/confirmation',
  browse: '/browse',
  browseDeparture: '/browse/departure',
  browseReturn: '/browse/return',
  browseSummary: '/browse/summary',
  royalHome: 'https://www.royalcaribbean.com',
  bookFlights: '/bookFlights',
  flightsCancellation: '/cancellation',
  amendDashboard: '/reservation/dashboard',
  resultsReturn: '/results/return',
  guestAccount: '/account',
  manage: '/manage',
  cancelConfirmation: '/cancel-confirmation',
  MANAGE_FLIGHTS_URL: 'flights/manage',
  rclHotels: 'https://hotels.royalcaribbean.com?wl_source=air',
  rclHotelsAuthenticated:
    'https://hotels.royalcaribbean.com/wl/r/hotel?mk=royal-j3zwephQT7kIhjGEPEQd&wl_source=air',
  // celebrity
  timeline: '/post-booking/travel-arrangements/timeline',
  manageVacations: '/post-booking/manage-vacation',
  paymentCelebrity: '/post-booking/payment',
  celHotels: 'https://hotels.celebritycruises.com/?wl_source=air',
  celHotelsAuthenticated:
    'https://hotels.celebritycruises.com/wl/r/hotel?mk=celeb-XwizMY739SYUZ3hnW0ka&wl_source=air',
};

export const MIN_AGE_TO_TRAVEL_ALONE = 12;
export const LOCAL_GRAPH_URI = 'http://localhost:8080/graph';
export const MIN_AGE_TO_ACCOMPANY_MINORS = 18;

export const FLIGHT_SEARCH_TYPE = {
  RETURN: 'return',
  DEPARTURE: 'departure',
};

export const ERROR_CODE017 = 'BKNG-0017';
export const TRACK_INCORRECT_SAILING = 'INCORRECT_SAILING_BOOKING_DATE';
export const TRACK_ERROR_CANCELLED = 'BOOKING_STATUS_CANCELLED';
export const ERROR_CODE098 = 'CSE0098';
export const FLIGHT_AGENCY_ERROR = 'FLIGHT_AGENCY_ERROR';
export const TRACK_INVAID = 'invalid';
export const ERROR_CODE293 = 'CSE0293';
export const PRICE_FILTER_STEP = 50;
export const TRACK_LOCKED = 'booking locked';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const TRACK_STATUS_CANCELLED = 'cancelled booking';
export const BOOKING_ID_URL = 'bookingId';
export const TRAVEL_AGENT = 'TA';
export const GROUP_BOOKING = 'GRP';
export const TRAVEL_AGENT_RESERVE = 'TA_RESERVE';
export const PAYMENT_REVERSAL_ERROR = 'PAYMENT_REVERSAL_ERROR';
export const SEARCH_SAME_AIRPORT_ERROR = 'SEARCH_SAME_AIRPORT_ERROR';
export const FLIGHT_ERROR = 'FLIGHT_ERROR';
export const ACE_FS_1006_ERROR = 'ACE-FS-1006';
export const ACE_FS_1028_ERROR = 'ACE-FS-1028';
export const ACE_FS_1019_ERROR = 'ACE-FS-1019';
export const BANNER_TYPES = {
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const SHOW_CH_ERROR_BANNER = {
  chMessagesBookingTypes: ['TA', 'GRP'],
};
export const GA_PROFILE_BOOKINGS_LENGTH = 'ga-profile-bookings-length';
export const HEADER_OPTIONS_PATHS = [
  'browse',
  'results',
  'review-flight',
  'payment',
  'confirmation',
  'error',
  'cancellation',
  'manage',
];

export const ROOT_PATH = 'flights';
export const LD_AMEND_FLAGS = 'ldFlags';
export const REDIRECTION_MANAGE = 'REDIRECTION_MANAGE';
export const UNDEFINED_GUESTS = {
  TBA: 'TBA',
  TBD: 'TBD',
};
export const ENABLE_CVV_COLLECTION = 'enable-cvv-collection';
export const SESSION_STORAGE_GUEST_ACCOUNT_CREATION = 'account-creation';

export const FLIGHT_TYPE_CODES = {
  ROUND_TRIP: 'RT',
  ONE_WAY: '1W',
};
export const COOKIE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  KEEP_ALIVE: 'keepAlive',
  LOYALTY_DATA: 'loyaltyData',
  VDS_ID: 'VDS_ID',
  CH_BOOKING_INFO: 'chBookingInfo',
  WUC: 'wuc',
};

export const BRAND = {
  ROYAL: 'royal',
  CELEBRITY: 'cel',
};

export const CEL_BOOK_PARAMS = {
  SAIL_DATE: 'sDT',
  SHIP_CODE: 'sCD',
  PACKAGE_CODE: 'pID',
  CRUISE_TYPE: 'sCT',
  GROUP_ID: 'groupId',
  COUNTRY: 'country',
};

export const CEL_CRUISE_TYPES = {
  CRUISETOUR: 'CT',
  CRUISE: 'CO',
};

export const ROYAL_BOOK_PARAMS = {
  SAIL_DATE: 'sailDate',
  SHIP_CODE: 'shipCode',
  PACKAGE_CODE: 'packageCode',
  DESTINATION_CODE: 'destinationCode',
  CURRENCY_CODE: 'selectedCurrencyCode',
  COUNTRY: 'country',
  GROUP_ID: 'groupId',
};

export const ALLOWED_CEL_REDIRECT_ISO_COUNTRIES = ['GBR', 'IRL', 'AUS', 'NZL', 'CAN'];
